import { toBoard } from '../mappers/board';
export const parseBoards = response => {
  const cursor = response.cursor || null;
  const size = response.items.length || null;
  response.data = (response.items || []).map(toBoard);
  response.paging = {
    cursor,
    size
  };
  return response;
};